/**
 * Cross-component coordination for ML prediction fetch/auto-apply suppression
 * on the /process page. Replaces the former (window as any).__mlBlackout /
 * __isApplyingPredictions globals with typed, testable module state.
 *
 * - blackout: a short time window after "Apply All" during which ML must not
 *   re-fetch; self-expiring (a missed clear simply lapses).
 * - applying: true while predictions are being applied; callers MUST clear it
 *   in a finally so a thrown error cannot suppress ML permanently.
 */
let blackoutUntil = 0;
let applying = false;

export function startMlBlackout(ms: number): void {
  blackoutUntil = Date.now() + ms;
}

export function isMlBlackoutActive(): boolean {
  return Date.now() < blackoutUntil;
}

export function clearMlBlackout(): void {
  blackoutUntil = 0;
}

export function setApplyingPredictions(v: boolean): void {
  applying = v;
}

export function isApplyingPredictions(): boolean {
  return applying;
}
